module.exports = __webpack_public_path__ + "/build/web/images/hero-search.cdf945505cd8a0b4bc9e8890161a9ea9.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero-search.jpg
// module id = 142
// module chunks = 13